export default {
  strict: true,
  namespaced: true,
  state: {
    ratings: {
      list: [],
      isMax: false,
      currentPage: 0,
      perPage: 20
    }
  },
  mutations: {
    resetRatings (state, value) {
      state.ratings.list = []
    },
    addRatings (state, value) {
      state.ratings.list.push(value)
    },
    setRatingsIsMax (state, value) {
      state.ratings.isMax = value
    },
    setRatingsCurrentPage (state, value) {
      state.ratings.currentPage = value
    }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/consumer/ratings.js